import { Button } from '@creditornot/cb-button';
import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography as T, typographyCss } from 'common/typography';

import CarouselImageOne from './images/Courier_partner_Austria.png';
import CarouselImageTwo from './images/Pet_store.png';
import CarouselImageThree from './images/TA_Sales.png';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-inline: auto;
  padding-inline: 16px;
  padding-block: 40px;
  width: 100%;
  max-width: 621px;
`;

const MiddleImageContainer = styled.div`
  height: 100%;
  width: 227px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-inline: 8px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: 137px;
  }
`;

const MiddleImage = styled.img`
  object-fit: cover;
  object-position: center;
  height: 115%;
  width: auto;
  margin-inline-end: -25%;
`;

const SideImageContainer = styled.div`
  height: 233px;
  width: 175px;
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  border-radius: 8px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: 138px;
    width: 98px;
  }
`;

const SideImage = styled.img`
  object-fit: cover;
  object-position: center;
  height: 100%;
  width: auto;
  border-radius: 8px;
  margin-block-start: -20%;
`;

const LeftImage = styled(SideImage)`
  height: 160%;
  margin-inline-end: -60%;
`;

const RightImage = styled(SideImage)`
  margin-block-start: -30%;
  height: 180%;
`;

const CarouselContainer = styled.div`
  height: 303px;
  display: flex;
  align-items: center;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    height: 183px;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;
  margin-block-start: 32px;
`;

const StyledButton = styled(Button).attrs({
  size: 'large',
  variant: 'blue',
})`
  width: 100%;
`;

const Heading = styled.h2`
  margin-block-start: 0;
  margin-block-end: 16px;
  ${typographyCss.Heading2}

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    ${typographyCss.Heading4}
  }
`;

const Subheading = styled(T.Body3)`
  text-align: center;
  margin-block-end: 28px;
  padding-inline: 10px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding-inline: 10px;
  }
`;

const WelcomeView = () => {
  const history = useHistory();

  return (
    <Wrapper>
      <CarouselContainer>
        <SideImageContainer>
          <LeftImage src={CarouselImageOne} alt="carousel image one" />
        </SideImageContainer>

        <MiddleImageContainer>
          <MiddleImage src={CarouselImageTwo} alt="carousel image two" />
        </MiddleImageContainer>

        <SideImageContainer>
          <RightImage src={CarouselImageThree} alt="carousel image three" />
        </SideImageContainer>
      </CarouselContainer>

      <ContentContainer>
        <Heading>Welcome, Emma!</Heading>

        <Subheading>
          Get ready to grow together by partnering with Wolt for Merchants. Start by completing your business
          information, and we’ll take it from there.
        </Subheading>

        <StyledButton onClick={() => history.push('/onboarding-wizard?step=venue-details&country=fin')}>
          Let’s start
        </StyledButton>
      </ContentContainer>
    </Wrapper>
  );
};

export default WelcomeView;
